
export class Payment {

  public MT:any;
  public Ref:any;
  public Trans:any;
  public order_id:any;
  public deadline_id:any;

  constructor() {}

}
